import { UserCard } from "@/components/users/UserCard";
import { useParams } from "react-router-dom";
import { useRoleProtected } from "@/hooks/useRoleProtected";
import { useGetUser } from "@/hooks/queryHooks/userHooks";

export const UserPage = () => {
  const { userId } = useParams();
  useRoleProtected("view");

  const { data: userData } = useGetUser(userId ?? "");

  if (!userData) return null;

  return (
    <div className="flex flex-col flex-grow">
      <div className="max-w-lg mx-auto">
        <UserCard user={userData} />
      </div>
    </div>
  );
};
